import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { productosPath } from 'src/app/shared/helpers/constants';
import { getLocalStorage } from 'src/app/shared/helpers/helper';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-login-sso',
  templateUrl: './login-sso.component.html',
  styleUrls: ['./login-sso.component.sass'],
})
export class LoginSsoComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    const tokenSso = getLocalStorage('token_sso');
    if (
      tokenSso != null &&
      tokenSso.tokenParsed != null &&
      !this.authService.isLoggedIn()
    ) {
      let invalidRequest = true;

      this.authService
        .authenticateSso(tokenSso)
        .pipe(finalize(() => (invalidRequest = false)))
        .subscribe(
          _ => {
            this.router.navigate([productosPath.path]);
          },
          error => (invalidRequest = true)
        );

      // this.authService.authenticateSso(tokenSso);
      // this.router.navigate([productosPath.path]);
    }
  }
}
